// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.loader_background_GM3o9 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 490;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--ui-white);
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  text-align: center;
  color: var(--text-primary);
  animation-duration: 0.25s;
  animation-iteration-count: 1;
  animation-name: loader_BG_SHOW_T304Q;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
  overflow: hidden;
}

.loader_fadeOut_MgKnn {
  animation-name: loader_BG_HIDE_kFSVq;
  animation-timing-function: ease-in;
  animation-fill-mode: forwards;
  pointer-events: none;
}

@keyframes loader_BG_SHOW_T304Q {
  from{
    opacity: 0;
    transform: translateY(-10px);
  }
  to{
    opacity: 1;
  }
}

@keyframes loader_BG_HIDE_kFSVq {
  from{
    opacity: 1;
  }
  to{
    opacity: 0;
    transform: translateY(20px);
  }
}

/* Both animations use 0.5s duration for consistency */

.loader_fullscreen_DHYRi {
  /* Break out of the layout using position: fixed to cover the whole screen */
  position: fixed;
  /* Use the fullscreen stage z-index to allow covering full-screen mode */
  z-index: 500;
}

.loader_title_SkTss {
  font-size: 2rem;
  font-weight: bold;
  margin: 0.75rem 0;
}

.loader_message_UX9Q3 {
  height: 20px;
  margin: 10px 0;
}

.loader_bar-outer_ya7DU {
  width: 300px;
  height: 8px;
  border-radius: 8px;
  background-color: var(--ui-secondary);
  overflow: hidden;
  position: relative;
  margin-left: auto;
}

.loader_container_C9iPh {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 100px;
  margin: auto 0
}

.loader_Tips_hRWl2{
  position: absolute;
  right: 7%;
  bottom: 7%;
}

.loader_bar-inner_oGyhe {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: var(--looks-secondary);
}

.loader_logoLoader_H6Zfy {
  transform: scale(6, 6) translate(20px, 40px) !important;
}

.loader_circle_ai7sN {
  width: 64px;
  height: 64px;
  border-radius: 200%;
  display: block;
  border-width: none;
  background-color: var(--looks-transparent);
}

@keyframes loader_circleA_1_jP1M7 {

  50%,
  0% {
    transform: translate(0px, 22px) scale(0.75, 0.75);
    opacity: 0;
  }

  75% {
    opacity: 1;
  }

  100% {
    transform: scale(1.95, 1.95);
  }
}

@keyframes loader_circleA_2_hXHf1 {

  20%,
  0% {
    transform: translate(0px, -52px) scale(0.5, 0.5);
    opacity: 0;
  }

  75% {
    opacity: 1;
  }

  100% {
    transform: translate(-25px, -12px) scale(0.96, 0.96);
  }
}

@keyframes loader_circleA_3_yK2ay {

  30%,
  0% {
    transform: translate(0px, -112px) scale(0.26, 0.26);
    opacity: 0;
  }

  75% {
    opacity: 1;
  }

  100% {
    transform: translate(40px, -108px) scale(1.46, 1.46);
  }
}

#loader_circle_1_P1QpI,
#loader_circle_2_QZFxh,
#loader_circle_3_M8_Zz {
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  transition: background-color 0.5s ease;
}

#loader_circle_1_P1QpI {
  animation-name: loader_circleA_1_jP1M7;
}

#loader_circle_2_QZFxh {
  animation-name: loader_circleA_2_hXHf1;
}

#loader_circle_3_M8_Zz {
  animation-name: loader_circleA_3_yK2ay;
}
`, "",{"version":3,"sources":["webpack://./src/components/loader/loader.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,2DAA2D;EAC3D,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,oCAAuB;EACvB,kCAAkC;EAClC,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,sDAAsD;;AAEtD;EACE,4EAA4E;EAC5E,eAAe;EACf,wEAAwE;EACxE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE;;IAEE,iDAAiD;IACjD,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,gDAAgD;IAChD,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;;EAEE;;IAEE,mDAAmD;IACnD,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,mCAAmC;EACnC,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,sCAAyB;AAC3B;;AAEA;EACE,sCAAyB;AAC3B;;AAEA;EACE,sCAAyB;AAC3B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 490;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--ui-white);\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  text-align: center;\n  color: var(--text-primary);\n  animation-duration: 0.25s;\n  animation-iteration-count: 1;\n  animation-name: BG_SHOW;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease-out;\n  overflow: hidden;\n}\n\n.fadeOut {\n  animation-name: BG_HIDE;\n  animation-timing-function: ease-in;\n  animation-fill-mode: forwards;\n  pointer-events: none;\n}\n\n@keyframes BG_SHOW {\n  from{\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to{\n    opacity: 1;\n  }\n}\n\n@keyframes BG_HIDE {\n  from{\n    opacity: 1;\n  }\n  to{\n    opacity: 0;\n    transform: translateY(20px);\n  }\n}\n\n/* Both animations use 0.5s duration for consistency */\n\n.fullscreen {\n  /* Break out of the layout using position: fixed to cover the whole screen */\n  position: fixed;\n  /* Use the fullscreen stage z-index to allow covering full-screen mode */\n  z-index: 500;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: bold;\n  margin: 0.75rem 0;\n}\n\n.message {\n  height: 20px;\n  margin: 10px 0;\n}\n\n.bar-outer {\n  width: 300px;\n  height: 8px;\n  border-radius: 8px;\n  background-color: var(--ui-secondary);\n  overflow: hidden;\n  position: relative;\n  margin-left: auto;\n}\n\n.container {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 100px;\n  margin: auto 0\n}\n\n.Tips{\n  position: absolute;\n  right: 7%;\n  bottom: 7%;\n}\n\n.bar-inner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: var(--looks-secondary);\n}\n\n.logoLoader {\n  transform: scale(6, 6) translate(20px, 40px) !important;\n}\n\n.circle {\n  width: 64px;\n  height: 64px;\n  border-radius: 200%;\n  display: block;\n  border-width: none;\n  background-color: var(--looks-transparent);\n}\n\n@keyframes circleA_1 {\n\n  50%,\n  0% {\n    transform: translate(0px, 22px) scale(0.75, 0.75);\n    opacity: 0;\n  }\n\n  75% {\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(1.95, 1.95);\n  }\n}\n\n@keyframes circleA_2 {\n\n  20%,\n  0% {\n    transform: translate(0px, -52px) scale(0.5, 0.5);\n    opacity: 0;\n  }\n\n  75% {\n    opacity: 1;\n  }\n\n  100% {\n    transform: translate(-25px, -12px) scale(0.96, 0.96);\n  }\n}\n\n@keyframes circleA_3 {\n\n  30%,\n  0% {\n    transform: translate(0px, -112px) scale(0.26, 0.26);\n    opacity: 0;\n  }\n\n  75% {\n    opacity: 1;\n  }\n\n  100% {\n    transform: translate(40px, -108px) scale(1.46, 1.46);\n  }\n}\n\n#circle_1,\n#circle_2,\n#circle_3 {\n  animation-duration: 1s;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  transition: background-color 0.5s ease;\n}\n\n#circle_1 {\n  animation-name: circleA_1;\n}\n\n#circle_2 {\n  animation-name: circleA_2;\n}\n\n#circle_3 {\n  animation-name: circleA_3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `loader_background_GM3o9`,
	"BG_SHOW": `loader_BG_SHOW_T304Q`,
	"bgShow": `loader_BG_SHOW_T304Q`,
	"fadeOut": `loader_fadeOut_MgKnn`,
	"BG_HIDE": `loader_BG_HIDE_kFSVq`,
	"bgHide": `loader_BG_HIDE_kFSVq`,
	"fullscreen": `loader_fullscreen_DHYRi`,
	"title": `loader_title_SkTss`,
	"message": `loader_message_UX9Q3`,
	"bar-outer": `loader_bar-outer_ya7DU`,
	"barOuter": `loader_bar-outer_ya7DU`,
	"container": `loader_container_C9iPh`,
	"Tips": `loader_Tips_hRWl2`,
	"tips": `loader_Tips_hRWl2`,
	"bar-inner": `loader_bar-inner_oGyhe`,
	"barInner": `loader_bar-inner_oGyhe`,
	"logoLoader": `loader_logoLoader_H6Zfy`,
	"circle": `loader_circle_ai7sN`,
	"circle_1": `loader_circle_1_P1QpI`,
	"circle1": `loader_circle_1_P1QpI`,
	"circle_2": `loader_circle_2_QZFxh`,
	"circle2": `loader_circle_2_QZFxh`,
	"circle_3": `loader_circle_3_M8_Zz`,
	"circle3": `loader_circle_3_M8_Zz`,
	"circleA_1": `loader_circleA_1_jP1M7`,
	"circleA1": `loader_circleA_1_jP1M7`,
	"circleA_2": `loader_circleA_2_hXHf1`,
	"circleA2": `loader_circleA_2_hXHf1`,
	"circleA_3": `loader_circleA_3_yK2ay`,
	"circleA3": `loader_circleA_3_yK2ay`
};
export default ___CSS_LOADER_EXPORT___;
